import { PageMVC } from "../KePages/page-mvc";

export class ServiceResultPageSequence {
    success: boolean;
    id: string;
    errorMessage: string;
    string: number;
    page: PageMVC;
}
